import { store } from 'store/configureStore';
import { RootReducer } from 'store/rootReducer';

export const getAuthStoreData = (): RootReducer['auth'] | undefined => {
    const state = store.getState();
    
return state?.auth;
};

export const getAuthToken = (): string | null | undefined => {
    const state = store.getState();
    
return state?.auth?.token;
};
